import router from './index'

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('X-Token')
  // 如果当前页面需要登录并且未登录
  if (!to.meta.loginNoRequired && !token && !to.name === 'home') {
    next({ name: 'login' })
  } else {
    next()
  }
})
